import beardLight from "./beard-light";
import beardMagestic from "./beard-magestic";
import beardMedium from "./beard-medium";
import blank from "./blank";
import moustacheFancy from "./moustache-fancy";
import moustacheMagnum from "./moustache-magnum";

export default {
	blank,
	beardLight,
	beardMagestic,
	beardMedium,
	moustacheFancy,
	moustacheMagnum,
};



// WEBPACK FOOTER //
// ./src/facial-hair/index.js